























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import ChatChannel from './ChatChannel.vue';
// eslint-disable-next-line no-unused-vars
import Timeline from '../../models/Timeline';
// eslint-disable-next-line no-unused-vars
import ChatMessage, { ChatSendPacketData } from '../../models/ChatMessage';
import { SendPacket } from '../../networking/SendPacket';
import { PacketType } from '../../models/Packet';
import ElementQueries from 'css-element-queries';
import BInputLimited from '@/components/input_limited/BInputLimited.vue';
import Mutations from '../../store/mutations';
import { mapGetters } from 'vuex';

@Component({
    components: {
        ChatChannel,
        BInputLimited
    },
    computed: {
        ...mapGetters([
            'timelineFormMode'
        ])
    },
    recomputed: {
        widthOffset()
        {
            let _this = this as ChatRoot;
            let width = _this.rootWidth;
            let formMode = _this.isFormMode;
			
            if(_this.$store.state.project.presentationFullSlide >= 0 || ((_this.$store.state.project.presentationMode || formMode) && window.innerWidth < 800))
            {
                width += 100;	//make chat button disappear on small screens if the timline form is open -- for some reason increasing the z-index of the form wasn't working (matt 10/14/2020)
            }
            return -width.toString() + 'px';
        },
        hide_content()
        {
            let _this = this as ChatRoot;
            return _this.bHidden && (new Date().getTime() - _this.lastHidden.getTime()) > 0.5;
        }
    }
})
export default class ChatRoot extends Vue 
{
	selected_tab = 0;
	unseen_message = false;
	can_have_unseen_message = false;
	unsubscribeFromMutations : any = null;

	// Note(Ian): For some reason, naming this member _hidden caused it to be undefined for the computed properties.  I'll look into that more at some point - might
	// be a Vue thing bc I couldn't find anything that suggested Typescript itself would be the culprit (though I admittedly didn't put much time into investigating it)
	private bHidden = true;
	private lastHidden = new Date("1/1/1970");
	private rootWidth = 400;
	private isFormMode = false;

	get hidden()
	{
	    return this.bHidden;
	}

	set hidden(value : boolean)
	{
	    this.bHidden = value;
	    this.lastHidden = new Date();

	    setTimeout(() => 
	    {
	        this.$nextTick(()=>
	        {
	            if(!this.bHidden)
	            {
	                (this.$refs.chatContainer as any).scrollTop = (this.$refs.chatContainer as any).scrollHeight;
	            } 
	        });
	    }, 50);

	    setTimeout(() => 
	    {
	        // Check in case the component is unmounted during the timeout
	        if ((this as any).hide_content)
	        {
	            this.$recompute("hide_content");
	        }

	        this.$nextTick(()=>
	        {
	            if(this.bHidden)
	            {
	                (this.$refs.openChatBtn as HTMLElement).focus();
	            } 
	            else
	            {
	                (this.$refs.chatContainer as any).scrollTop = (this.$refs.chatContainer as any).scrollHeight;
	                (this.$refs.chatInputField as HTMLElement).focus();
	            }
	        });
	    }, 550);
	}

	chat_text = "";
	resizeSensor : ElementQueries.ResizeSensor | null = null;

	mounted()
	{
	    // This way it doesn't pick up initial messages as unseen
	    setTimeout(() => 
	    {
	        this.can_have_unseen_message = true;
	    }, 500);

	    this.$nextTick(() =>
	    {
	        this.resizeSensor = new ElementQueries.ResizeSensor(this.$refs.chatRoot as HTMLDivElement, () =>
	        {
	            this.$nextTick(() =>
	            {
	                this.isFormMode = (this as any).timelineFormMode;
	                this.rootWidth = (this.$refs.chatRoot as any).clientWidth;
	                this.$recompute('widthOffset');
	            });
	        });
	    });

	    this.unsubscribeFromMutations = this.$store.subscribe((mutation, state) =>
	    {
	        if (mutation.type == Mutations.chatMessage)
	        {
	            this.messageReceived();
	        }
	    });
	}

	beforeDestroy()
	{
	    if (this.unsubscribeFromMutations != null)
	        this.unsubscribeFromMutations();
	}

	get timeline() : Timeline
	{
	    let val = this.$store.state.project.activeTimeline;
	    if (!val)
	    {
	        this.selected_tab = 0;
	    }
	    else
	    {
	        console.log(`NEW TIMELINE: ${val.id}`);
	    }
	    return val;
	}

	get timeline_id() : number
	{
	    return this.timeline ? this.timeline.id : -1;
	}
	
	get cur_channel() : number
	{
	    if (this.timeline)
	    {
	        console.log(`Trying to do - ID == ${this.timeline_id}`);
	        return this.selected_tab == 0 ? 0 : this.timeline_id + 1;
	    }
	    return 0;
	}

	messageReceived()
	{
	    if (this.hidden && this.can_have_unseen_message)
	    {
	        this.unseen_message = true;
	    }
	}

	sendChatMsg()
	{
	    if (this.chat_text == "")
	        return;
		
	    let packet = new ChatSendPacketData;
	    packet.text = this.chat_text;
	    packet.channel = this.cur_channel;
	    console.log(packet);
	    SendPacket(PacketType.Chat, packet);

	    this.chat_text = "";
	    setTimeout(() => 
	    {
	        this.$nextTick(()=>
	        {
	            if(!this.bHidden)
	            {
	                (this.$refs.chatContainer as any).scrollTop = (this.$refs.chatContainer as any).scrollHeight;
	            } 
	        });
	    }, 500);
	}
}
